module.exports = ['$sce', 'Strings', function ($sce, Strings) {
    return {
        restrict: "E",
        templateUrl: '/static/partials/components/daterange_picker.html',
        scope: {
            form: "=",
            reportOptions: "=",
            source: "="
        },
        replace: true,
        controller: "ReportDateRangePicker",
        controllerAs: "date_range_picker",
        link: function link($scope, $element, $attrs) {

        }
    };
}];
